import React from 'react';
import { UploadIcon } from '../Icons';
type UploadItem = {
	name: string;
	size?: number;
};

type UploadBoxProps = {
	maxSize?: number;
	files?: UploadItem[];
	onSelect?: (files: FileList) => void;
	onDelete?: (index: number) => void;
	accept?: string;
	title?: string;
	multiple?: boolean;
};

export default function UploadBox({
	maxSize = 50,
	files: filesProp = [],
	onSelect,
	onDelete,
	accept,
	title = 'Rohdaten hochladen',
	multiple = true,
}: UploadBoxProps) {
	const files = filesProp;

	return (
		<div className="w-full">
			<label className="flex py-6 w-full cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-[#999999] bg-white px-6 text-center transition hover:bg-[#EDF4FA]">
				       <input
					       type="file"
					       multiple={multiple}
					       accept={accept}
					       className="hidden"
					       onChange={(e) => {
						       if (e.target.files) onSelect?.(e.target.files);
					       }}
				       />

				<div className="mb-2 flex h-11 w-11 items-center justify-center rounded-full bg-[#EDF4FA] border border-[#d6e6f4]">
					<UploadIcon />
				</div>

				<h4 className="text-sm leading-tight text-[#333333] mb-0">
					{title}
				</h4>

				<p className="text-sm text-[#666666]">
					Maximale Uploadgröße: {maxSize} MB
				</p>
			</label>

			
		</div>
	);
}